<h3 class="with-manual-link">
  <span i18n="@@privacy">Datenschutz</span>
  <app-manual-link
    href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/Datenschutz"></app-manual-link>
</h3>
<div class="container">
  <div class="section">
    <h3 i18n="@@content-filter">Inhaltsfilter</h3>
    <div class="section-content">
      <div class="row">
        <div class="col-3">
          <span i18n="@@stop-words">Stoppwörter</span>
          <app-hint i18n="@@stop-words-hint">
            Hier kannst du <b>individuelle</b> Stoppwörter für den Bot festlegen, die nicht an den Bot geschickt werden
            sollen.<br>Einzelne Stoppwörter können eingetippt und mit Enter hinzugefügt werden.
          </app-hint>
        </div>
        <div class="col">
          <app-bot-word-stop
            [botConfig]="this.rss.botConfig"
            (botConfigChange)="this.rss.saveBotConfigField('stopWords')"
          ></app-bot-word-stop>
        </div>
      </div>
      <div class="row">
        <div class="col-3">
          <span i18n="@@word-replacement">Wortersetzung</span>
          <app-hint i18n="@@word-replacement-hint">
            Hier kannst du <b>individuelle</b> Wortersetzungen festlegen, die automatisch ersetzt werden, bevor sie an
            den Bot geschickt werden.
          </app-hint>
        </div>
        <div class="col">
          <app-bot-word-replace
            [botConfig]="this.rss.botConfig"
            (botConfigChange)="this.rss.saveBotConfigField('wordReplacements')"
          ></app-bot-word-replace>
        </div>
      </div>
    </div>
  </div>

  <div class="section">
    <h3 i18n="@@housekeeping">Datenpflege</h3>
    <div class="section-content">
      <app-bot-history-cleanup></app-bot-history-cleanup>
      <app-form-for-boolean
        [label]="this.deleteGuestsAfterNotice"
        [value]="this.rss.botConfig.deleteGuestsAfterDays > 0"
        (valueChange)="this.onDeleteGuestsAfterDaysToggle($event)"
      >
        <app-hint i18n="@@delete-guests-after-notice-hint">
          Hier kann angegeben werden, nach wievielen Tagen die Daten (inkl. Chatverläufe) von nicht eingeloggten
          Gästen entfernt werden sollen.
        </app-hint>
        @if (this.rss.botConfig.deleteGuestsAfterDays > 0) {
          <input
            afterToggle
            pInputText
            type="number"
            fluid
            min="1"
            style="width: 100px;"
            [(ngModel)]="this.rss.botConfig.deleteGuestsAfterDays"
            [ngModelOptions]="{updateOn: 'blur'}"
            (ngModelChange)="this.rss.saveBotConfigField('deleteGuestsAfterDays')"
          >
        }
      </app-form-for-boolean>
    </div>
  </div>

  <div class="section">
    <h3 i18n="@@privacy-notice">Datenschutzhinweis</h3>
    <div class="section-content">
      <div class="d-flex align-items-center gap-2 mb-3">
        <p-tabs
          [(value)]="this.selectedComplianceLocale"
          [scrollable]="true"
          class="flex-grow-1 overflow-hidden"
        >
          <p-tablist>
            @for (option of this.localeOptions; track option.code) {
            <p-tab [value]="option.code">{{ option.name }}</p-tab>
            }
          </p-tablist>
        </p-tabs>
        <app-hint i18n="@@privacy-notice-language-hint">
          Diese Auswahl legt nur fest, für welche Sprache du diesen Datenschutzhinweis gerade ansiehst und
          bearbeitest. Die Sprache des Bots selbst wird dadurch nicht verändert.
        </app-hint>
      </div>
      <div>
        <p>
          <span i18n="@@custom-privacy-notice">Bot-spezifischer Datenschutzhinweis</span>
          <app-hint i18n="@@custom-privacy-notice-hint">
            Hier kannst du einen <b>individuellen</b> Datenschutzbanner verfassen, der beim Aufruf des Bots angezeigt
            wird.
            <br>
            Über „Zurücksetzen" lässt sich die Standardvorlage wiederherstellen.
          </app-hint>
        </p>
        <div class="d-flex mb-2 gap-2">
          <p-button
            size="small"
            severity="secondary"
            [outlined]="true"
            (onClick)="this.reset()"
            i18n-label="@@reset"
            label="Zurücksetzen"
          ></p-button>
          <p-button
            size="small"
            severity="danger"
            [outlined]="true"
            (onClick)="this.deleteText()"
            i18n-label="@@delete-text"
            label="Text löschen"
          ></p-button>
        </div>
      </div>
      <app-codemirror-ai
        [instruction]="this.rss.botConfig.complianceText[this.selectedComplianceLocale] ?? ''"
        [rows]="20"
        (finish)="this.rss.botConfig.complianceText[this.selectedComplianceLocale] = $event; this.rss.saveBotConfigField('complianceText')"
      ></app-codemirror-ai>
    </div>
  </div>

  <div class="section">
    <h3 i18n="@@storageccess-notice">Storage Access Hinweis</h3>
    <div class="d-flex align-items-center gap-2 mb-3">
      <p-tabs
        [(value)]="this.selectedStorageAccessLocale"
        [scrollable]="true"
        class="flex-grow-1 overflow-hidden"
      >
        <p-tablist>
          @for (option of this.localeOptions; track option.code) {
          <p-tab [value]="option.code">{{ option.name }}</p-tab>
          }
        </p-tablist>
      </p-tabs>
      <app-hint i18n="@@storageaccess-notice-language-hint">
        Diese Auswahl legt nur fest, für welche Sprache du diesen Storage Access Hinweis gerade ansiehst und
        bearbeitest. Die Sprache des Bots selbst wird dadurch nicht verändert.
      </app-hint>
    </div>
    <div>
      <p>
        <span i18n="@@custom-storageaccess-notice">Benutzerdefinierter Storage Access text</span>
        <app-hint i18n="@@custom-storageaccess-hint">
          Hier kannst du einen Text verfassen, der bei unzureichender Browserberechtigung dem Nutzer angezeigt wird,
          damit dieser seine Browser-Einstellung ändert bzw. die Berechtigung erteilt.
        </app-hint>
      </p>
    </div>
    <textarea
      pInputTextarea
      type="text"
      class="w-100"
      [(ngModel)]="this.rss.botConfig.storageaccessText[this.selectedStorageAccessLocale]"
      (ngModelChange)="this.rss.saveBotConfigField('storageaccessText')"
      [ngModelOptions]="{updateOn: 'blur'}"
      rows="20"
    ></textarea>
  </div>
</div>